import { AccountLOB, AccountStatus, } from '@ally/data-types-afg-accounts';
import { getDomainData as getCustomizationDomainData } from '@ally/data-selectors-customization';
import { createSelector } from 'reselect';
import { getDomainData } from './selectors';
import { formatCreditCardAccountsForDropdown } from './utils';
/**
 * Returns all credit card accounts or an empty array.
 */
var getAllCreditCardAccounts = createSelector(getDomainData, function (domain) { var _a, _b; return (_b = (_a = domain === null || domain === void 0 ? void 0 : domain.data) === null || _a === void 0 ? void 0 : _a.filter(function (account) { return [AccountLOB.CC].includes(account.lob); })) !== null && _b !== void 0 ? _b : []; });
/**
 * This selector utility returns a selector that takes getAllCreditCardAccounts as
 * its first selector and uses the combiner you pass to transform the afg account data
 */
var createCreditCardSelector = function (combiner) {
    return createSelector(getAllCreditCardAccounts, combiner);
};
var getOpenCreditCardAccounts = createCreditCardSelector(function (accounts) {
    return accounts.filter(function (_a) {
        var status = _a.status;
        return status === AccountStatus.NORMAL_STATUS;
    });
});
var getCreditCardAccountsForDropdown = createSelector(getAllCreditCardAccounts, getCustomizationDomainData, function (accounts, customizationOptions) {
    return formatCreditCardAccountsForDropdown(accounts, customizationOptions);
});
export default {
    getAll: getAllCreditCardAccounts,
    getAllForDropdown: getCreditCardAccountsForDropdown,
    getOpen: getOpenCreditCardAccounts,
};
//# sourceMappingURL=creditCard.js.map